// import {FilterAltIcon }from '@mui/icons-material';
// import { FaFilter } from "react-icons/fa";
import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsSankey from 'highcharts/modules/sankey';
import { Box } from '@mui/material';
HighchartsSankey(Highcharts);

const options = {
  // Highcharts.chart('container', {

  title: {
    text: ''
    // enabled: false
  },
  // subtitle: {
  //     text:
  //   'Source: <a href=\'https://www.llnl.gov/\'> Lawrence Livermore National Laboratory</a>'
  // },
  accessibility: {
    point: {
      valueDescriptionFormat: '{index}. {point.from} to {point.to}, {point.weight}.'
    }
  },
  tooltip: {
    headerFormat: null,
    pointFormat: '{point.fromNode.name} \u2192 {point.toNode.name}: {point.weight} People',
    nodeFormat: '{point.name}: {point.sum:.2f} People'
    // nodeFormat: undefined
  },
  series: [
    {
      keys: ['from', 'to', 'weight'],

      // data: [
      //   ['Entry', 'Mobile1', 15],
      //   ['Entry', 'PlayStation1', 8],
      //   ['Entry', 'Laptop1', 6],
      //   ['Entry', 'Accessories1', 4],
      //   ['Entry', 'Help desk1', 5],
      //   ['Entry', 'Accessoriesxit1', 2],

      //   ['PlayStation1', 'Mobile2', 0.5],
      //   ['Laptop1', 'Mobile2', 1],
      //   ['Accessories1', 'Mobile2', 1],
      //   ['Help desk1', 'Mobile2', 1],
      //   // [ 'Accessoriesxit1', 'Mobile2', 1],

      //   ['Mobile1', 'PlayStation2', 5],
      //   ['Laptop1', 'PlayStation2', 1],
      //   ['Accessories1', 'PlayStation2', 1],
      //   ['Help desk1', 'PlayStation2', 1],
      //   // [ 'Accessoriesxit1', 'PlayStation2', 1],

      //   ['Mobile1', 'Laptop2', 3],
      //   ['PlayStation1', 'Laptop2', 0.5],
      //   ['Accessories1', 'Laptop2', 1],
      //   ['Help desk1', 'Laptop2', 1],
      //   // [ 'Accessoriesxit1', 'Laptop2', 1],

      //   ['Mobile1', 'Accessories2', 7],
      //   ['PlayStation1', 'Accessories2', 0.5],
      //   ['Laptop1', 'Accessories2', 1],
      //   ['Help desk1', 'Accessories2', 1],
      //   // [ 'Accessoriesxit1', 'Accessories2', 1],

      //   ['Mobile1', 'Help desk2', 2],
      //   ['PlayStation1', 'Help desk2', 0.5],
      //   ['Laptop1', 'Help desk2', 1],
      //   ['Accessories1', 'Help desk2', 1],
      //   // [ 'Accessoriesxit1', 'Help desk2', 1],

      //   ['Mobile1', 'Accessoriesxit2', 3],
      //   ['PlayStation1', 'Accessoriesxit2', 0.5],
      //   ['Laptop1', 'Accessoriesxit2', 1],
      //   ['Accessories1', 'Accessoriesxit2', 1],
      //   ['Help desk1', 'Accessoriesxit2', 1],

      //   //=======
      //   ['PlayStation2', 'Mobile3', 1],
      //   ['Laptop2', 'Mobile3', 1],
      //   ['Accessories2', 'Mobile3', 1],
      //   ['Help desk2', 'Mobile3', 1],
      //   // [ 'Accessoriesxit2', 'Mobile3', 1],

      //   ['Mobile2', 'PlayStation3', 1],
      //   ['Laptop2', 'PlayStation3', 1],
      //   ['Accessories2', 'PlayStation3', 1],
      //   ['Help desk2', 'PlayStation3', 1],
      //   // [ 'Accessoriesxit2', 'PlayStation3', 1],

      //   ['Mobile2', 'Laptop3', 1],
      //   ['PlayStation2', 'Laptop3', 1],
      //   ['Accessories2', 'Laptop3', 1],
      //   ['Help desk2', 'Laptop3', 1],
      //   // [ 'Accessoriesxit2', 'Laptop3', 1],

      //   ['Mobile2', 'Accessories3', 1],
      //   ['PlayStation2', 'Accessories3', 1],
      //   ['Laptop2', 'Accessories3', 1],
      //   ['Help desk2', 'Accessories3', 1],
      //   // [ 'Accessoriesxit2', 'Accessories3', 1],

      //   ['Mobile2', 'Help desk3', 1],
      //   ['PlayStation2', 'Help desk3', 1],
      //   ['Laptop2', 'Help desk3', 1],
      //   ['Accessories2', 'Help desk3', 1],
      //   // [ 'Accessoriesxit2', 'Help desk3', 1],

      //   ['Mobile2', 'Accessoriesxit3', 1],
      //   ['PlayStation2', 'Accessoriesxit3', 1],
      //   ['Laptop2', 'Accessoriesxit3', 1],
      //   ['Accessories2', 'Accessoriesxit3', 1],
      //   ['Help desk2', 'Accessoriesxit3', 1],

      //   //=======
      //   ['PlayStation3', 'Mobile4', 1],
      //   ['Laptop3', 'Mobile4', 1],
      //   ['Accessories3', 'Mobile4', 1],
      //   ['Help desk3', 'Mobile4', 1],
      //   // [ 'Accessoriesxit3','Mobile4', 1],

      //   ['Mobile3', 'PlayStation4', 1],
      //   ['Laptop3', 'PlayStation4', 1],
      //   ['Accessories3', 'PlayStation4', 1],
      //   ['Help desk3', 'PlayStation4', 1],
      //   // [ 'Accessoriesxit3','PlayStation4', 1],

      //   ['Mobile3', 'Laptop4', 1],
      //   ['PlayStation3', 'Laptop4', 1],
      //   ['Accessories3', 'Laptop4', 1],
      //   ['Help desk3', 'Laptop4', 1],
      //   // [ 'Accessoriesxit3','Laptop4', 1],

      //   ['Mobile3', 'Accessories4', 1],
      //   ['PlayStation3', 'Accessories4', 1],
      //   ['Laptop3', 'Accessories4', 1],
      //   ['Help desk3', 'Accessories4', 1],
      //   // [ 'Accessoriesxit3','Accessories4', 1],

      //   ['Mobile3', 'Help desk4', 1],
      //   ['PlayStation3', 'Help desk4', 1],
      //   ['Laptop3', 'Help desk4', 1],
      //   ['Accessories3', 'Help desk4', 1],
      //   // [ 'Accessoriesxit3','Help desk4', 1],

      //   ['Mobile3', 'Accessoriesxit4', 1],
      //   ['PlayStation3', 'Accessoriesxit4', 1],
      //   ['Laptop3', 'Accessoriesxit4', 1],
      //   ['Accessories3', 'Accessoriesxit4', 1],
      //   ['Help desk3', 'Accessoriesxit4', 1],

      //   //=======
      //   ['PlayStation4', 'Mobile5', 1],
      //   ['Laptop4', 'Mobile5', 1],
      //   ['Accessories4', 'Mobile5', 1],
      //   ['Help desk4', 'Mobile5', 1],
      //   ['Accessoriesxit4', 'Mobile5', 1],

      //   ['Mobile4', 'PlayStation5', 1],
      //   ['Laptop4', 'PlayStation5', 1],
      //   ['Accessories4', 'PlayStation5', 1],
      //   ['Help desk4', 'PlayStation5', 1],
      //   ['Accessoriesxit4', 'PlayStation5', 1],

      //   ['Mobile4', 'Laptop5', 1],
      //   ['PlayStation4', 'Laptop5', 1],
      //   ['Accessories4', 'Laptop5', 1],
      //   ['Help desk4', 'Laptop5', 1],
      //   ['Accessoriesxit4', 'Laptop5', 1],

      //   ['Mobile4', 'Accessories5', 1],
      //   ['PlayStation4', 'Accessories5', 1],
      //   ['Laptop4', 'Accessories5', 1],
      //   ['Help desk4', 'Accessories5', 1],
      //   ['Accessoriesxit4', 'Accessories5', 1],

      //   ['Mobile4', 'Help desk5', 1],
      //   ['PlayStation4', 'Help desk5', 1],
      //   ['Laptop4', 'Help desk5', 1],
      //   ['Accessories4', 'Help desk5', 1],
      //   ['Accessoriesxit4', 'Help desk5', 1],

      //   ['Mobile4', 'Accessoriesxit5', 1],
      //   ['PlayStation4', 'Accessoriesxit5', 1],
      //   ['Laptop4', 'Accessoriesxit5', 1],
      //   ['Accessories4', 'Accessoriesxit5', 1],
      //   ['Help desk4', 'Accessoriesxit5', 1],

      //   ['Mobile5', 'Accessoriesxit6', 1],
      //   ['PlayStation5', 'Accessoriesxit6', 1],
      //   ['Laptop5', 'Accessoriesxit6', 1],
      //   ['Accessories5', 'Accessoriesxit6', 1],
      //   ['Help desk5', 'Accessoriesxit6', 1]
      // ],
      data: [],

      type: 'sankey',
      name: 'Sankey demo series',
      dataLabels: {
        enabled: false // Disable data labels for nodes
      }
    }
  ]

  // });
};

//  function handelChange(e){
//     console.log(e.target.value);
//  }

const Sankey = () => {
  return (
    <Box
    //  sx={{width: "100vw", height:"100vh", display:"flex", justifyContent:"center", alignItems:"center"}}
    >
      {/* <Paper sx={{width:"80%", position:"relative", maxWidth:"800px"}}> */}
      {/* <Box sx={{width:"95%", display:"flex", justifyContent:"space-between", padding:"10px", height:"50%"}}>
        <Box sx={{ width:"120px", p:"10px", outline:"none"}}>
        <FormControl fullWidth>
 
  <NativeSelect
    inputProps={{
      name: 'graph',
      id: 'uncontrolled-native',
    }}
    onChange={handelChange}
  >
    
    <option value="journey">Journey</option>
    <option value="engagement">Engagemant</option>
    <option value="footfall">Footfall</option>
  </NativeSelect>
</FormControl>
      </Box>

      
     <FaFilter style={{background:"black", borderRadius:"8px", color:"white" , padding: "10px", cursor:"pointer"}} />
      </Box> */}

      <HighchartsReact highcharts={Highcharts} options={options} />
      <div style={{ background: 'white', width: '80px', height: '15px', position: 'absolute', right: '0', bottom: '0' }}></div>
      {/* </Paper> */}
    </Box>
  );
};

export default Sankey;
